module.exports = __webpack_public_path__ + "static/img/citrus-cherry-m.0224405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/citrus-cherry-m.jpg
// module id = 2ylf
// module chunks = 0